import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import VerticalNavBar from "../VerticalNavBar";
import React, { useState, useEffect } from "react";
import { GrLinkNext } from "react-icons/gr";
import API from "../../utils/api";
import {
  Card as MuiCard,
  CardContent,
  Typography,
  Button as MuiButton,
  Box,
} from "@mui/material";
import styled from "styled-components";
import { format } from "date-fns";
import { marked } from "marked";
import DOMPurify from "dompurify";
import CheatSheet from "./CheatSheet";

const Card = styled(MuiCard)`
  background-color: #1b1a2ea9;
  color: white;
  box-shadow: 0 4px 5px 3px rgba(119, 53, 136, 0.459);
  transition: all 0.5s ease 0.5s;
  &:hover {
    ${"" /* transform: scale(1.02); */}
    box-shadow: 0 4px 4px 5px rgba(129, 72, 144, 0.561);
  }
`;

const DateTypography = styled(Typography)`
  font-size: 1rem;
  text-align: right;
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
  color: var(--imp-text-color);
`;

const TitleTypography = styled(Typography)`
  font-size: 1.5rem;
  @media (max-width: 768px) {
    font-size: 1.025rem;
  }
  font-weight: 500;
  color: white;
`;

const LinkToResourceButton = styled(MuiButton)`
  background-color: #623686;
  color: #fff;
  &:hover {
    background-color: #6d20c5d7;
  }
`;

const ContentBox = styled(Box)`
  color: white;
  white-space: normal;
  text-align: left;
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  letter-spacing: 0.5px;
  word-spacing: 1px;
  font-size: 1.2rem;
  @media (max-width: 768px) {
    font-size: 0.725rem;
  }
  /* Remove margin and padding from paragraphs or line breaks */
  p {
    margin: 0;
    padding: 0.35rem;
    @media (max-width: 768px) {
      padding: 0rem;
    }
  }
  h3 {
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }
  h4 {
    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
  h5,
  h6 {
    @media (max-width: 768px) {
      font-size: 0.7rem;
    }
  }
  br {
    margin: 0;
    padding: 0.5rem;
    @media (max-width: 768px) {
      padding: 0rem;
    }
  }
`;

function Revision(props) {
  props.setLearning(true);
  const [data, setData] = useState({
    lastRevised: new Date(),
    title: "",
    description: "",
    link: "",
  });

  const formatDate = (date) => {
    return format(new Date(date), "EEE, do MMM yyyy: h:mma");
  };

  // Convert Markdown to HTML
  const createMarkup = (markdownText) => {
    const html = marked(markdownText);
    return { __html: DOMPurify.sanitize(html) };
  };
  const [change, setChange] = useState(0);
  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/learning/getRevisionData")
      .then((res) => res.data)
      .then((response) => {
        if (response.success) {
          setData(response.data.revisionData);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, [change]);
  return (
    <>
      <Particle />
      <Container fluid className="revision-section">
        <Col>
          <Row>
            <VerticalNavBar
              setIsAuthenticated={props.setIsAuthenticated}
              setLearning={props.setLearning}
            />
          </Row>
        </Col>
        <Container>
          <h1>Refresh...</h1>
          <Card>
            <input value={change} hidden></input>
            <CardContent>
              <DateTypography>{formatDate(data.lastRevised)}</DateTypography>
              <TitleTypography>{data.title}</TitleTypography>
              <br />
              <Box display="flex" justifyContent="flex-end"></Box>
              <Box display="flex" justifyContent="center">
                <ContentBox
                  dangerouslySetInnerHTML={createMarkup(data.description)}
                />
              </Box>
              <br />
              <Box display="flex" justifyContent="flex-end">
                {data.link !== "" && (
                  <LinkToResourceButton
                    size="small"
                    href={data.link}
                    target="_blank"
                  >
                    Resource Link
                  </LinkToResourceButton>
                )}
              </Box>
              <br />
              <Button
                className="primary"
                size="small"
                onClick={async (e) => {
                  e.preventDefault();
                  try {
                    await API.post("/api/learning/completeRevision", {
                      id: data._id,
                    }).then(() => {
                      setChange(change + 1);
                    });
                  } catch (err) {
                    alert("Error in server");
                  }
                }}
              >
                Next <GrLinkNext style={{ marginBottom: "2px" }} />
              </Button>
            </CardContent>
          </Card>
        </Container>
        <Container>
          <br />
          <br />
          <h1>Cheat Sheets</h1>
          <CheatSheet />
        </Container>
      </Container>
    </>
  );
}

export default Revision;
